type UsageMetric = {
  used: number;
  limit: number;
};

export const normalizeUsageMetric = (metric?: UsageMetric | null) => {
  const used = metric?.used;
  const limit = metric?.limit;
  const isAvailable =
    typeof used === "number" &&
    typeof limit === "number" &&
    Number.isFinite(used) &&
    Number.isFinite(limit) &&
    used >= 0 &&
    limit >= 0;

  if (!isAvailable) {
    return {
      isAvailable: false,
      isLimitReached: false,
      used: 0,
      limit: 0,
      progress: 0,
    };
  }

  return {
    isAvailable: true,
    isLimitReached: used >= limit,
    used,
    limit,
    progress: limit > 0 ? (used * 100) / limit : 100,
  };
};
